<form
  [formGroup]="serviceRequestForm"
  (ngSubmit)="submitForm($event)"
  class="service-request-form"
>
  <div fxLayout="row" fxLayout.lt-md="column" class="form-grid">
    <div fxFlex="25" class="field">
      <label>{{ "Status" | translate }}</label>
      <span class="asterisk">*</span>
      <nz-select
        nzShowSearch
        nzAllowClear
        class="width-100"
        [nzPlaceHolder]="'Select status' | translate"
        formControlName="statusId"
        [nzLoading]="isLookupLoading"
      >
        @for (option of dropdownData?.statuses; track option.id) {
          <nz-option
            [nzLabel]="option.display"
            [nzValue]="option.id"
          ></nz-option>
        }
      </nz-select>
    </div>

    <div fxFlex="25" class="field">
      <label>{{ "Intent" | translate }}</label>
      <span class="asterisk">*</span>
      <nz-select
        nzShowSearch
        [appTerminologySearch]="dropdownData?.intents"
        nzAllowClear
        class="width-100"
        [nzPlaceHolder]="'Select intent' | translate"
        formControlName="intentId"
        [nzLoading]="isLookupLoading"
      >
        @for (option of dropdownData?.intents; track option.id) {
          <nz-option
            [nzLabel]="option.display"
            [nzValue]="option.id"
          ></nz-option>
        }
      </nz-select>
    </div>

    <div fxFlex="25" class="field">
      <label>{{ "Priority" | translate }}</label>
      <nz-select
        nzShowSearch
        [appTerminologySearch]="dropdownData?.priorities"
        nzAllowClear
        class="width-100"
        [nzPlaceHolder]="'Select priority' | translate"
        formControlName="priorityId"
        [nzLoading]="isLookupLoading"
      >
        @for (option of dropdownData?.priorities; track option.id) {
          <nz-option
            [nzLabel]="option.display"
            [nzValue]="option.id"
          ></nz-option>
        }
      </nz-select>
    </div>

    <div fxFlex="25" class="field">
      <label>{{ "Category" | translate }}</label>
      <nz-select
        nzShowSearch
        nzServerSearch
        nzAllowClear
        class="width-100"
        nzDropdownClassName="service-request-category-dropdown"
        [nzPlaceHolder]="'Select category' | translate"
        formControlName="categoryId"
        [nzLoading]="categoryState.isLoading"
        (nzOnSearch)="onCategorySearch($event)"
        (nzScrollToBottom)="loadMoreCategories()"
        (nzOpenChange)="onCategoryOpenChange($event)"
      >
        @for (option of categoryState.options; track option.id) {
          <nz-option
            [nzLabel]="option.display"
            [nzValue]="option.id"
          ></nz-option>
        }
      </nz-select>
    </div>
  </div>

  <div fxLayout="row" fxLayout.lt-md="column" class="form-grid">
    <div fxFlex="50" class="field">
      <label>{{ "Procedure code" | translate }}</label>
      <span class="asterisk">*</span>
      <nz-select
        nzShowSearch
        nzServerSearch
        nzAllowClear
        class="width-100"
        nzDropdownClassName="service-request-procedure-code-dropdown"
        [nzPlaceHolder]="'Select procedure code' | translate"
        formControlName="procedureCodeId"
        [nzLoading]="procedureCodeState.isLoading"
        (nzOnSearch)="onProcedureCodeSearch($event)"
        (nzScrollToBottom)="loadMoreProcedureCodes()"
        (nzOpenChange)="onProcedureCodeOpenChange($event)"
      >
        @for (option of procedureCodeState.options; track option.id) {
          <nz-option
            [nzLabel]="option.display"
            [nzValue]="option.id"
          ></nz-option>
        }
      </nz-select>
    </div>

    <div fxFlex="50" class="field">
      <label>{{ "Procedure reason" | translate }}</label>
      <nz-select
        nzShowSearch
        nzServerSearch
        nzAllowClear
        class="width-100"
        nzDropdownClassName="service-request-procedure-reason-dropdown"
        [nzPlaceHolder]="'Select procedure reason' | translate"
        formControlName="procedureReasonId"
        [nzLoading]="procedureReasonState.isLoading"
        (nzOnSearch)="onProcedureReasonSearch($event)"
        (nzScrollToBottom)="loadMoreProcedureReasons()"
        (nzOpenChange)="onProcedureReasonOpenChange($event)"
      >
        @for (option of procedureReasonState.options; track option.id) {
          <nz-option
            [nzLabel]="option.display"
            [nzValue]="option.id"
          ></nz-option>
        }
      </nz-select>
    </div>
  </div>

  <div fxLayout="row" fxLayout.lt-md="column" class="form-grid">
    <div fxFlex="50" class="field">
      <label>{{ "Occurrence" | translate }}</label>
      <nz-range-picker
        class="width-100"
        formControlName="occurrence"
      ></nz-range-picker>
      @if (hasInvalidOccurrence) {
        <div class="validation-error">
          {{
            "Occurrence end must be after or equal to occurrence start"
              | translate
          }}
        </div>
      }
    </div>

    <div fxFlex="50" class="field checkbox-field form-row">
      <label nz-checkbox formControlName="asNeeded" class="checkbox-label">
        {{ "As needed" | translate }}
      </label>
    </div>
  </div>

  <div fxLayout="row" fxLayout.lt-md="column" class="form-grid">
    <div fxFlex="50" class="field">
      <label>{{ "Description" | translate }}</label>
      <textarea nz-input rows="3" formControlName="description"></textarea>
    </div>

    <div fxFlex="50" class="field">
      <label>{{ "Order detail value" | translate }}</label>
      <textarea nz-input rows="3" formControlName="orderDetailValue"></textarea>
    </div>
  </div>

  <div class="field">
    <label>{{ "Notes" | translate }}</label>
    <textarea nz-input rows="3" formControlName="notes"></textarea>
  </div>

  <div class="form-actions">
    <button
      nz-button
      nzPrimary
      class="save-btn"
      type="submit"
      [nzLoading]="isLoading"
      [disabled]="isLoading || isLookupLoading"
    >
      {{ "Save" | translate }}
    </button>
    <button
      nz-button
      nzDanger
      class="cancel-btn"
      type="button"
      (click)="handleCancel()"
      [disabled]="isLoading"
    >
      {{ "Cancel" | translate }}
    </button>
  </div>
</form>
